<template  >
  <div v-if="bankId == 4520 || bankId == 4521 || bankId == 4522" class="display-flex align-items-center justify-content-space-between card card-20">
    <div v-if="bankId == 4520">
      <div class="text-color-gray">{{$t('general-text-from')}}</div>
      <div class="fw-medium">{{$t('month-'+startMonth+'-mmm')}} {{year}}</div>
    </div>
    <div v-if="bankId == 4521 || bankId == 4522">
      <div class="text-color-gray">{{ $t('sendmoney-philgov-label-transaction-type') }}</div>
      <div class="fw-medium">{{$t('sendmoney-philgov-'+bankBranchId)}}</div>

      <div v-if="showLoanNumber" class="mt-20 text-color-gray">{{$t('sendmoney-philgov-label-loan-number')}}</div>
      <div v-if="showLoanNumber" class="fw-medium">{{loanNumber}}</div>

      <div v-if="showPRNNumber" class="mt-20 text-color-gray">{{$t('sendmoney-philgov-label-prn-number')}}</div>
      <div v-if="showPRNNumber" class="fw-medium">{{prnNo}}</div>

      <div v-if="showMP2No" class="mt-20 text-color-gray">{{$t('sendmoney-philgov-label-mp2')}}</div>
      <div v-if="showMP2No" class="fw-medium">{{mp2No}}</div>

      <div  v-if="showPeriod" class="mt-20 text-color-gray">{{$t('general-text-period')}}</div>
      <div v-if="showPeriod" class="fw-medium"> {{$t('month-'+startMonth+'-mmm')}} {{year }} - {{$t('month-'+endMonth+'-mmm')}} {{year}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        bankId         : 0,
        bankBranchId   : 0,
        bankTypeId     : 0,
        endMonth       : 0,
        loanNumber     : '',
        mp2No          : '',
        prnNo          : 0,
        startMonth     : 0,
        year           : 0,
        showLoanNumber : false,
        showPRNNumber  : false,
        showMP2No      : false,
        showPeriod     : false,
      }
    },
    mounted(){
      this.bankId       = this.$store.state.transaction.bankId
      this.bankBranchId = this.$store.state.transaction.bankBranchId
      this.bankTypeId   = this.$store.state.transaction.bankTypeId
      this.endMonth     = this.$store.state.transaction.endMonth
      this.loanNumber   = this.$store.state.transaction.loanNumber
      this.mp2No        = this.$store.state.transaction.mp2No
      this.prnNo        = this.$store.state.transaction.prnNo
      this.startMonth   = this.$store.state.transaction.startMonth
      this.year         = this.$store.state.transaction.startYear

      this.showLoanNumber = (this.bankBranchId == 619404 || this.bankBranchId == 619408) ? true : false
      this.showMP2No      = (this.bankBranchId == 619402) ? true : false
      this.showPRNNumber  = (this.bankBranchId == 619407 || this.bankBranchId == 619406) ? true : false
      this.showPeriod     = (this.bankBranchId == 619404 || this.bankBranchId == 619401 || this.bankBranchId == 619408 || this.bankBranchId == 619405) ? true : false
    },
  }
</script>